import namespacedStorage from './namespaced-storage'

export const getCtaStorage = () => {
  return namespacedStorage('toast-oo-cta')
}
